import { FilterInterface } from '../interfaces/intarfaces';
import { FilterPlaceHolderEnum } from '../enums/filter.enum';

export const overviewPageFilter: MainFilterInterface = {
  countSort: [
    {
      id: 1,
      value: 10,
      text: 'ÐÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑ Ð¿Ð¾ 10',
    },
    {
      id: 2,
      value: 50,
      text: 'ÐÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑ Ð¿Ð¾ 50',
    },
    {
      id: 3,
      value: 100,
      text: 'ÐÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑ Ð¿Ð¾ 100',
    },
    {
      id: 4,
      value: 'all',
      text: 'ÐÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑ Ð²ÑÐµ',
    },
  ],
  fieldSort: [
    {
      id: 1,
      value: 'ASC',
      text: 'ÐÐ¾ Ð°Ð»ÑÐ°Ð²Ð¸ÑÑ Ð-Ð¯',
    },
    {
      id: 2,
      value: 'cadaster',
      text: 'ÐÐ¾ ÐºÐ°Ð´Ð°ÑÑÑÐ¾Ð²Ð¾Ð¼Ñ Ð½Ð¾Ð¼ÐµÑÑ',
    },
    {
      id: 3,
      value: 'houseDate',
      text: 'ÐÐ¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð´Ð¾Ð¼Ð°',
    },
  ],
  placeholder: FilterPlaceHolderEnum.OverviewPlaceholderFilter,
};

export const emNumbersPageFilter: MainFilterInterface = {
  countSort: overviewPageFilter.countSort,
  fieldSort: [
    {
      id: 1,
      value: 'ASC',
      text: 'ÐÐ¾ Ð°Ð»ÑÐ°Ð²Ð¸ÑÑ Ð-Ð¯',
    },
    {
      id: 2,
      value: 'phone',
      text: 'ÐÐ¾ Ð½Ð¾Ð¼ÐµÑÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
    },
  ],
  placeholder: FilterPlaceHolderEnum.EmNumbersPlaceholderFilter,
};

export const adsPageFilter: MainFilterInterface = {
  countSort: overviewPageFilter.countSort,
  fieldSort: [
    {
      id: 1,
      value: 'activityDate',
      text: 'ÐÐ¾ Ð´Ð°ÑÐµ Ð°ÐºÑÐ¸Ð²Ð½Ð¾ÑÑÐ¸',
    },
    {
      id: 2,
      value: 'creationDate',
      text: 'ÐÐ¾ Ð´Ð°ÑÐµ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ',
    },
  ],
  placeholder: FilterPlaceHolderEnum.AdsPlaceholderFilter,
};

export interface MainFilterInterface {
  countSort: FilterInterface[];
  fieldSort: FilterInterface[];
  placeholder: FilterPlaceHolderEnum;
}
